/**
 * Shared wording for credit-card amounts in the accountant P&L views (Tyler, 2026-11-02).
 *
 * The pl-grid and multi-source views add itemized card charges (credit_card_statement rows)
 * to the bank rows as-is; the engines exclude card rows. The phrase tells the CPA the card
 * amounts are itemized charges and are not netted against any bank outflow that paid the card.
 * Label only: no figure depends on this text.
 */
export const CARD_CHARGES_NOTE = 'itemized card charges, not netted against bank';

/** Sentence-case form for a stand-alone sub-line. */
export const CARD_CHARGES_NOTE_SENTENCE = 'Itemized card charges, not netted against bank';
